// removed by extract-text-webpack-plugin
module.exports = {"pof":"popup__pof__b9k15","wrapper":"popup__wrapper__2wppw popup__pof__b9k15","cache":"popup__cache__2o1VH popup__pof__b9k15","popup":"popup__popup__2ED82","btn":"popup__btn__1oXGR","cancel":"popup__cancel___8qRy popup__btn__1oXGR","confirm":"popup__confirm__o-PMQ popup__btn__1oXGR"};


//////////////////
// WEBPACK FOOTER
// ./src/popup/popup.scss
// module id = 205
// module chunks = 0